import {
  Typography,
  OutlinedInput,
  Grid,
} from "@mui/material";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

const GuestContactInformation = () => {
  const { control, setValue, watch, getValues } = useFormContext();

const formatPhoneNumber = (digits: string) => {
            const cleaned = digits.replace(/\D/g, "").slice(0, 10); // force max 10 digits
            if (cleaned.length === 0) return "";
            if (cleaned.length <= 3) return `(${cleaned}`;
            if (cleaned.length <= 6) return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
            // return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}${cleaned.slice(6)}`;
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        };
  
  const renderNumberField = (
    label: string,
    name: "Phone",
    placeholder: string
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        rules={ name == "Phone" ? {
          required: "Please enter Phone", 
          pattern: {
            value: /^\d{10}/, 
            message: "Phone number must be 10 digits",
          },
          maxLength: {
            value: 10,
            message: "Phone number must be 10 digits"
          }  
        } : {}
      }
        render={({ field, fieldState: { error } }) => (
        <>
            <OutlinedInput
              {...field}
              placeholder={placeholder}
              fullWidth
              autoComplete="off"
            value={formatPhoneNumber(field.value ?? "")}
              onChange={
                (e) => {
                if (e.target.value.length <= 14) {
                  field.onChange(
                    e.target.value.replace(/\D/g, "").slice(0, 14) || ""
                  )
                }
                }}
            sx={{ height: "40px", fontSize: "14px", borderColor: error ? "red" : undefined}}
          />
          { error && (
                  <Typography
                    className="error-text"
                    color="error"
                    fontSize="12px"
                  >
                   {error.message}
                  </Typography>
                )}
          </>
        )}
      />
    </>
  );

  const renderInputField = (
    label: string,
    name: "ShopName" | "FirstName" | "LastName" | "Email"| "ConfirmEmail",
    placeholder: string
  ) => (
    <>
      <Typography className="form-label" variant="h6" gutterBottom>
        {label}
      </Typography>
      <Controller
        name={name}
        control={control}
        rules={name == "ShopName" ? {
          minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 50,
            message: "Maximum 50 characters allowed"
          }
        } : name == "FirstName" ? {
            required: "Please enter First Name",  
            minLength: {
            value: 2,
            message: "Minimum 2 characters required"
          },
          maxLength: {
            value: 50,
            message: "Maximum 50 characters allowed"
          }
        } : name == "LastName" ? {
           required: "Please enter Last Name",  
            minLength: {
            value: 3,
            message: "Minimum 3 characters required"
          },
          maxLength: {
            value: 50,
            message: "Maximum 50 characters allowed"
          }
        } : name =="Email" ? {
          required: "Please enter Email",  
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Invalid email address",
          }
        } : name == "ConfirmEmail" ? {
          required: "Please enter Confirm Email",  
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Invalid email address",
            },
            validate : (value: string) =>
            value?.trim().toLowerCase() === getValues("Email")?.trim().toLowerCase() || "Your email entries must match"
        } : {}
      }
        render={({ field, fieldState: { error } }) => (
        <>
          <OutlinedInput
            {...field}
            placeholder={placeholder}
            fullWidth
            autoComplete="off"
            value={field.value || ""}
              onChange={
                (e) => {
                  if (field.name == "ShopName" || field.name == "FirstName" || field.name == "LastName") {
                    if (e.target.value.length <= 50) {
                      field.onChange(
                        e.target.value.slice(0, 50) || ""
                      )
                    }
                  }
                  else if (field.name == "Email" || field.name == "ConfirmEmail") {
                    field.onChange(e.target.value.replace(/\s+/g, '') || "")
                  }
                  else{
                    field.onChange(e.target.value || "")
                  }
                }
              }
              onBlur={(e) => {
                 if (field.name == "ShopName" || field.name == "FirstName" || field.name == "LastName") {
                      const trimmed = e.target.value.trim();
                      setValue(field.name, trimmed, { shouldValidate: true });
                 }
              }}
            sx={{ height: "40px", fontSize: "14px", borderColor: error ? "red" : undefined}}
          />
          { error && (
                  <Typography
                    className="error-text"
                    color="error"
                    fontSize="12px"
                  >
                   {error.message}
                  </Typography>
                )}
          </>
        )}
      />
    </>
  );

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Shop Name", "ShopName", "Enter Shop Name")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("First Name*", "FirstName", "Enter First Name")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Last Name*", "LastName", "Enter Last Name")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Email*", "Email", "Enter Email")}
      </Grid>
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderInputField("Confirm Email*", "ConfirmEmail", "Enter Confirm Email")}
      </Grid>

      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        {renderNumberField("Phone*", "Phone", "Enter Phone")}
      </Grid>

    </Grid>
  );
};

export default GuestContactInformation;
